const styles = {
  card: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    boxShadow: "0px 0px 8px 0px rgba(0, 0, 0, 0.05)",
    borderRadius: 12,
    backgroundColor: "#fff",
    marginTop: "4px",
    marginLeft: " 10px",
    marginRight: " 14px",
    marginBottom: " 10px",

    // overflow: "scroll",
  },
  title: {
    padding: "8px 16px 0px 16px",
    display: "flex",
    flexDirection: "row",
  },

  dropDown: {
    padding: "16px 16px 16px 16px",
  },

  main: {
    padding: "0.5rem",
    flex: 1,
  },
  footer: {
    display: "flex",
    padding: "3px 18px",
    minHeight: 18,
    justifyContent: "flex-end",
    // backgroundColor: "#043D90",
    borderBottomRightRadius: 12,
    borderBottomLeftRadius: 12,
  },
};

export default styles;
